import React, { useState, useEffect, useLayoutEffect, useMemo, useRef } from 'react';
import { createPortal } from 'react-dom';
import AnimateOnScroll from './AnimateOnScroll';
import './SeccionProyectos.css';

const RUTA_BASE = process.env.PUBLIC_URL || '';
const RUTA_PROYECTOS = `${RUTA_BASE}/img/proyectos/seccion proyecto`;

/**
 * Una entrada por carpeta numérica bajo `public/img/proyectos/seccion proyecto/<n>/`.
 * Imágenes numeradas: 1.jpg, 2.jpg, … (o .jpeg según la carpeta).
 */
function archivosNumerados(cantidad, extension = 'jpg') {
  return Array.from({ length: cantidad }, (_, i) => `${i + 1}.${extension}`);
}

const DEFINICION_PROYECTOS = [
  { id: 1, nombre: 'Reopen S.A - General Rodriguez', carpeta: '1', archivos: archivosNumerados(4) },
  { id: 2, nombre: 'Pirelli - Planta Merlo', carpeta: '2', archivos: archivosNumerados(3) },
  { id: 3, nombre: 'Disprofarm', carpeta: '3', archivos: archivosNumerados(6) },
  { id: 4, nombre: 'Club y Biblioteca Mariano Moreno', carpeta: '4', archivos: archivosNumerados(4) },
  { id: 5, nombre: 'Alejandro Diaz, Ituzaingo - Bs. As.', carpeta: '5', archivos: archivosNumerados(5) },
  {
    id: 6,
    nombre: 'industrias plasticas - Ariel Machay',
    carpeta: '6',
    archivos: [
      'WhatsApp Image 2026-04-09 at 13.52.57 (1).jpeg',
      'WhatsApp Image 2026-04-09 at 13.52.57.jpeg',
      'WhatsApp Image 2026-04-09 at 13.52.58 (1).jpeg',
      'WhatsApp Image 2026-04-09 at 13.52.58 (2).jpeg',
      'WhatsApp Image 2026-04-09 at 13.52.58.jpeg',
      'WhatsApp Image 2026-04-09 at 13.52.59 (1).jpeg',
      'WhatsApp Image 2026-04-09 at 13.52.59.jpeg',
    ],
  },
  { id: 7, nombre: 'Parque Industrial Buen Ayre - Moreno', carpeta: '7', archivos: archivosNumerados(5) },
  { id: 8, nombre: 'Olympus Sport Center - CABA', carpeta: '8', archivos: archivosNumerados(4) },
  { id: 9, nombre: 'Las Canarias - Merlo', carpeta: '9', archivos: archivosNumerados(8) },
  { id: 10, nombre: 'Sport Club - Castelar', carpeta: '10', archivos: archivosNumerados(3) },
  { id: 11, nombre: 'Río Grande - Tierra del Fuego', carpeta: '11', archivos: archivosNumerados(4) },
  { id: 12, nombre: 'Fit & Sports - Hurlingham', carpeta: '12', archivos: archivosNumerados(5) },
  { id: 13, nombre: 'Amentuel S.A., Ciudadela. Obra llave en mano.', carpeta: '13', archivos: archivosNumerados(8) },
  { id: 14, nombre: 'Proyecto 14', carpeta: '14', archivos: archivosNumerados(9, 'jpeg') },
  { id: 15, nombre: 'Industrias Frigoríficas Sur S.A. - Churruca', carpeta: '15', archivos: archivosNumerados(12, 'jpeg') },
  { id: 16, nombre: 'Industrias Frigoríficas Sur S.A. - Gral. Pico, La Pampa', carpeta: '16', archivos: archivosNumerados(6, 'jpeg') },
  { id: 17, nombre: 'Transtony Srl - San Andrés', carpeta: '17', archivos: archivosNumerados(10, 'jpeg') },
  { id: 18, nombre: 'Pastas Gaeta - Marcos Paz', carpeta: '18', archivos: archivosNumerados(12, 'jpeg') },
  { id: 19, nombre: 'Acoplados Salto S.A. - Parque Industrial Morón', carpeta: '19', archivos: archivosNumerados(7, 'jpeg') },
  { id: 20, nombre: 'Tecla srl - Hurlingham', carpeta: '20', archivos: archivosNumerados(18, 'jpeg') },
  { id: 21, nombre: 'Avimas - Mercedes', carpeta: '21', archivos: archivosNumerados(7, 'jpeg') },
];

function rutaImagen(carpeta, archivo) {
  return `${RUTA_PROYECTOS}/${carpeta}/${archivo}`;
}

const PROYECTOS = DEFINICION_PROYECTOS.map((p) => {
  const ordenados = [...p.archivos].sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
  return {
    id: p.id,
    nombre: p.nombre,
    imagen: rutaImagen(p.carpeta, ordenados[0]),
    imagenes: ordenados.map((f) => rutaImagen(p.carpeta, f)),
  };
});

function getPorLinea() {
  if (typeof window === 'undefined') return 3;
  return window.matchMedia('(max-width: 900px)').matches ? 2 : 3;
}

function ModalGaleria({ proyecto, onCerrar }) {
  const tituloId = `modal-galeria-titulo-${proyecto.id}`;
  const [imagenGrande, setImagenGrande] = useState(null);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key !== 'Escape') return;
      if (imagenGrande) {
        setImagenGrande(null);
        return;
      }
      onCerrar();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onCerrar, imagenGrande]);

  if (typeof document === 'undefined') return null;

  return createPortal(
    <>
      <div
        className="seccion-proyectos-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby={tituloId}
      >
        <button
          type="button"
          className="seccion-proyectos-modal__backdrop"
          aria-label="Cerrar galería"
          onClick={onCerrar}
        />
        <div className="seccion-proyectos-modal__panel">
          <div className="seccion-proyectos-modal__cabecera">
            <h3 id={tituloId} className="seccion-proyectos-modal__titulo">
              {proyecto.nombre}
            </h3>
            <button type="button" className="seccion-proyectos-modal__cerrar" onClick={onCerrar} aria-label="Cerrar">
              ×
            </button>
          </div>
          <div className="seccion-proyectos-modal__galeria">
            {proyecto.imagenes.map((src, i) => {
              const srcEncoded = encodeURI(src);
              const altMini = `${proyecto.nombre} — imagen ${i + 1} de ${proyecto.imagenes.length}`;
              return (
                <figure key={src} className="seccion-proyectos-modal__fig">
                  <button
                    type="button"
                    className="seccion-proyectos-modal__thumb"
                    onClick={() => setImagenGrande({ src: srcEncoded, alt: altMini })}
                    aria-label={`Ampliar imagen ${i + 1}`}
                  >
                    <img
                      src={srcEncoded}
                      alt={altMini}
                      className="seccion-proyectos-modal__img"
                      loading="lazy"
                    />
                  </button>
                </figure>
              );
            })}
          </div>
        </div>
      </div>

      {imagenGrande ? (
        <div
          className="seccion-proyectos-modal-lightbox"
          role="dialog"
          aria-modal="true"
          aria-label="Imagen ampliada"
        >
          <button
            type="button"
            className="seccion-proyectos-modal-lightbox__backdrop"
            aria-label="Cerrar vista ampliada"
            onClick={() => setImagenGrande(null)}
          />
          <div className="seccion-proyectos-modal-lightbox__marco">
            <button
              type="button"
              className="seccion-proyectos-modal-lightbox__cerrar"
              onClick={() => setImagenGrande(null)}
              aria-label="Cerrar"
            >
              ×
            </button>
            <img
              src={imagenGrande.src}
              alt={imagenGrande.alt}
              className="seccion-proyectos-modal-lightbox__img"
              decoding="async"
            />
          </div>
        </div>
      ) : null}
    </>,
    document.body
  );
}

function indiceVisualInicial(total) {
  return total > 1 ? 1 : 0;
}

function SeccionProyectos() {
  const carouselSurfaceRef = useRef(null);
  const navegandoRef = useRef(false);
  const [flechaTopPx, setFlechaTopPx] = useState(null);
  const [porLinea, setPorLinea] = useState(getPorLinea);
  const [slide, setSlide] = useState(0);
  const [visualSlide, setVisualSlide] = useState(() =>
    indiceVisualInicial(Math.ceil(PROYECTOS.length / getPorLinea()))
  );
  const [sinTransicion, setSinTransicion] = useState(false);
  const [proyectoModal, setProyectoModal] = useState(null);
  const totalSlides = Math.ceil(PROYECTOS.length / porLinea);

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 900px)');
    const apply = () => setPorLinea(mq.matches ? 2 : 3);
    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply);
    else mq.addListener(apply);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', apply);
      else mq.removeListener(apply);
    };
  }, []);

  const liberarNavegacion = () => {
    navegandoRef.current = false;
  };

  const irAnterior = () => {
    if (totalSlides <= 1 || navegandoRef.current) return;
    navegandoRef.current = true;
    setSinTransicion(false);
    setSlide((s) => (s - 1 + totalSlides) % totalSlides);
    setVisualSlide((v) => v - 1);
  };

  const irSiguiente = () => {
    if (totalSlides <= 1 || navegandoRef.current) return;
    navegandoRef.current = true;
    setSinTransicion(false);
    setSlide((s) => (s + 1) % totalSlides);
    setVisualSlide((v) => v + 1);
  };

  const PAGES = useMemo(
    () =>
      Array.from({ length: totalSlides }, (_, pageIndex) =>
        PROYECTOS.slice(pageIndex * porLinea, pageIndex * porLinea + porLinea)
      ),
    [totalSlides, porLinea]
  );

  const PAGES_EXT = useMemo(() => {
    if (totalSlides <= 1) return PAGES;
    return [PAGES[totalSlides - 1], ...PAGES, PAGES[0]];
  }, [PAGES, totalSlides]);

  const snapSinAnimacion = (nuevoIndice) => {
    setSinTransicion(true);
    setVisualSlide(nuevoIndice);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setSinTransicion(false);
        liberarNavegacion();
      });
    });
  };

  useEffect(() => {
    setSlide(0);
    setVisualSlide(indiceVisualInicial(totalSlides));
    setSinTransicion(true);
    navegandoRef.current = false;
    requestAnimationFrame(() => setSinTransicion(false));
  }, [porLinea, totalSlides]);

  useLayoutEffect(() => {
    if (totalSlides <= 1) {
      setFlechaTopPx(null);
      return;
    }

    const root = carouselSurfaceRef.current;
    if (!root) return;

    const sync = () => {
      const imgWrap = root.querySelector('.seccion-proyectos__imagen-wrap');
      if (!imgWrap) {
        setFlechaTopPx(null);
        return;
      }
      const rootRect = root.getBoundingClientRect();
      const imgRect = imgWrap.getBoundingClientRect();
      const center = imgRect.top + imgRect.height / 2 - rootRect.top;
      setFlechaTopPx(Number.isFinite(center) ? center : null);
    };

    sync();

    let ro;
    if (typeof ResizeObserver !== 'undefined') {
      ro = new ResizeObserver(sync);
      ro.observe(root);
      const firstImg = root.querySelector('.seccion-proyectos__imagen-wrap');
      if (firstImg) ro.observe(firstImg);
    }

    window.addEventListener('resize', sync);
    return () => {
      ro?.disconnect();
      window.removeEventListener('resize', sync);
    };
  }, [totalSlides, porLinea]);

  const handleTrackTransitionEnd = (e) => {
    if (e.target !== e.currentTarget || e.propertyName !== 'transform') return;
    if (totalSlides <= 1) {
      liberarNavegacion();
      return;
    }
    if (visualSlide === 0) {
      snapSinAnimacion(totalSlides);
      return;
    }
    if (visualSlide === totalSlides + 1) {
      snapSinAnimacion(1);
      return;
    }
    liberarNavegacion();
  };

  return (
    <section id="proyectos" className="seccion-proyectos" aria-labelledby="seccion-proyectos-titulo">
      <h2 id="seccion-proyectos-titulo" className="seccion-proyectos__titulo">
        Proyectos
      </h2>

      {proyectoModal ? (
        <ModalGaleria proyecto={proyectoModal} onCerrar={() => setProyectoModal(null)} />
      ) : null}

      <AnimateOnScroll className="seccion-proyectos__carousel-wrap" delay={0}>
        <div
          ref={carouselSurfaceRef}
          className="seccion-proyectos__carousel-surface"
          style={
            flechaTopPx != null
              ? { '--proyectos-flecha-top': `${flechaTopPx}px` }
              : undefined
          }
        >
        <div className="seccion-proyectos__viewport" aria-live="polite">
          <div
            className={`seccion-proyectos__track ${sinTransicion ? 'seccion-proyectos__track--no-transition' : ''}`}
            onTransitionEnd={handleTrackTransitionEnd}
            style={{ transform: `translateX(-${visualSlide * 100}%)` }}
          >
            {PAGES_EXT.map((page, pageIndex) => (
              <div
                key={pageIndex}
                className="seccion-proyectos__page"
                aria-hidden={pageIndex !== visualSlide}
              >
                <div className="seccion-proyectos__grid">
                  {page.map((proyecto) => (
                    <div key={proyecto.id} className="seccion-proyectos__tarjeta">
                      <div className="seccion-proyectos__imagen-wrap">
                        <img
                          src={encodeURI(proyecto.imagen)}
                          alt={proyecto.nombre}
                          className="seccion-proyectos__imagen"
                          loading="lazy"
                        />
                      </div>
                      <div className="seccion-proyectos__tarjeta-pie">
                        <h3 className="seccion-proyectos__nombre">{proyecto.nombre}</h3>
                        <button
                          type="button"
                          className="seccion-proyectos__ver-mas"
                          onClick={() => setProyectoModal(proyecto)}
                        >
                          Ver más
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        {totalSlides > 1 && (
          <>
            <button
              type="button"
              className="seccion-proyectos__btn seccion-proyectos__btn--prev"
              onClick={irAnterior}
              aria-label="Proyectos anteriores"
            >
              <span className="seccion-proyectos__flecha" aria-hidden="true">
                ‹
              </span>
            </button>
            <button
              type="button"
              className="seccion-proyectos__btn seccion-proyectos__btn--next"
              onClick={irSiguiente}
              aria-label="Siguientes proyectos"
            >
              <span className="seccion-proyectos__flecha" aria-hidden="true">
                ›
              </span>
            </button>
            <div className="seccion-proyectos__dots" role="tablist" aria-label="Seleccionar página de proyectos">
              {Array.from({ length: totalSlides }, (_, i) => (
                <button
                  key={i}
                  type="button"
                  role="tab"
                  aria-selected={i === slide}
                  aria-label={`Ir a página ${i + 1}`}
                  className={`seccion-proyectos__dot ${i === slide ? 'seccion-proyectos__dot--activo' : ''}`}
                  onClick={() => {
                    if (navegandoRef.current) return;
                    setSlide(i);
                    setVisualSlide(indiceVisualInicial(totalSlides) + i);
                    setSinTransicion(false);
                  }}
                />
              ))}
            </div>
          </>
        )}
        </div>
      </AnimateOnScroll>

      <AnimateOnScroll className="seccion-proyectos__cta-wrap" delay={100}>
        <p className="seccion-proyectos__cta-texto">¿Quieres ver más?</p>
        <a
          href="/docs/folleto/folleto.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="seccion-proyectos__cta-btn"
        >
          Ver folleto
        </a>
      </AnimateOnScroll>
    </section>
  );
}

export default SeccionProyectos;
